import { motion } from "framer-motion";
import { MaskLines, Eyebrow } from "./Reveal";

export const PageHeader = ({ eyebrow, lines, intro, children, testId }) => (
  <section className="relative pt-36 sm:pt-44 pb-14 sm:pb-20 overflow-hidden" data-testid={testId}>
    <div className="glow-orb" aria-hidden="true" />
    <div className="container-site relative">
      <Eyebrow>{eyebrow}</Eyebrow>
      <MaskLines lines={lines} className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tight text-[#F7F4EB]" />
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.45 }}
          className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-[#D6CFC0]"
        >
          {intro}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
